type MenuImageProps = {
  imageUrl: string;
  menuName: string;
};

export default function MenuImage({ imageUrl, menuName }: MenuImageProps) {
  return (
    <div className="relative w-full bg-gray-100">
      <img src={imageUrl} alt={menuName} className="w-full h-auto" loading="eager" />
      {/* Gradient overlay for header icon visibility */}
      <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-black/25 to-transparent pointer-events-none" />
    </div>
  );
}
